import { render } from "./Dropdown4.vue?vue&type=template&id=794da964"
import script from "./Dropdown4.vue?vue&type=script&lang=ts"
export * from "./Dropdown4.vue?vue&type=script&lang=ts"
script.render = render

export default script